<template>
  <div class="records-page">
    <div class="invoice-top">
      <header class="invoice-nav">
        <strong>开票中心</strong>
      </header>
      <nav class="invoice-tabs">
        <button type="button" @click="openApply">开票申请</button>
        <button type="button" class="active">开票记录</button>
      </nav>
    </div>
    <main>
      <article v-for="item in records" :key="item.request_no" @click="open(item)">
        <div><strong>{{ item.invoice_type_text }}</strong><span :class="statusClass(item.status)">{{ item.status }}</span></div>
        <h3>{{ item.invoice_title }}</h3>
        <p>申请单号：{{ item.request_no }}</p>
        <p>申请时间：{{ formatDate(item.submitted_at) }}</p>
        <b>¥{{ money(item.total_amount) }}</b>
      </article>
      <button v-if="nextCursor" class="load-more" :disabled="loading" @click="load">{{ loading ? '加载中...' : '加载更多' }}</button>
      <p v-if="!records.length && !loading" class="empty">暂无开票记录</p>
    </main>
  </div>
</template>
<script>
import { callHideToolbar, phoneBackButtonListener } from "@/bridge/AppJsBridge";
import { getInvoiceRecords } from "@/apis/invoiceCenter";
import { consumeInvoiceSession } from "./session";
import { closeInvoiceCenter, formatMoney, formatTime, handleInvoiceError } from "./common";
import { ensureInvoiceTrackingContext, getInvoiceType, trackInvoiceEvent } from "./tracking";
export default {
  data() { return { session: '', records: [], nextCursor: '', loading: false, viewTracked: false }; },
  async created() {
    this.session = consumeInvoiceSession(this.$route);
    callHideToolbar(true);
    phoneBackButtonListener(() => this.closePage());
    try {
      await ensureInvoiceTrackingContext(this.session);
      await this.load();
    } catch (error) {
      handleInvoiceError(error);
    }
  },
  mounted() { window.addEventListener('scroll', this.onScroll, { passive: true }); },
  beforeDestroy() { window.removeEventListener('scroll', this.onScroll); callHideToolbar(false); },
  methods: {
    money: formatMoney, formatDate: formatTime,
    openApply() {
      trackInvoiceEvent("INVOICE_APPLY_TAB_CLICK", { from_page: "invoice_records" });
      this.$router.push('/gameJump/invoiceCenter');
    },
    closePage() {
      trackInvoiceEvent("INVOICE_CENTER_CLOSE_CLICK", { from_page: "invoice_records" });
      closeInvoiceCenter();
    },
    open(item) {
      trackInvoiceEvent("INVOICE_RECORD_DETAIL_CLICK", {
        request_no: item.request_no,
        invoice_type: getInvoiceType(item.invoice_type || item.invoice_type_text),
        request_status: item.status_code || item.status,
        request_status_name: item.status,
      });
      this.$router.push('/gameJump/invoiceCenter/records/' + item.request_no);
    },
    statusClass(status) { return status === '开票成功' ? 'success' : status === '开票失败' ? 'failed' : 'pending'; },
    onScroll() { const root = document.documentElement; if (this.nextCursor && !this.loading && root.scrollTop + window.innerHeight >= root.scrollHeight - 120) this.load(); },
    async load() {
      if (this.loading) return; this.loading = true;
      try {
        const page = await getInvoiceRecords(this.session, { cursor: this.nextCursor || undefined, page_size: 10 });
        this.records = this.records.concat(page.list || []);
        this.nextCursor = page.next_cursor || '';
        if (!this.viewTracked) {
          this.viewTracked = true;
          trackInvoiceEvent("INVOICE_RECORD_VIEW", { record_count: this.records.length });
        }
      } catch (error) {
        handleInvoiceError(error);
      } finally { this.loading = false; }
    },
  },
};
</script>
<style lang="scss" scoped>
.records-page { min-height: 100%; background: #f5f6f8; color: #222; }
.invoice-top { position: sticky; top: 0; z-index: 5; background: #fff; }
.invoice-nav { height: 58px; display: flex; align-items: center; justify-content: space-between; padding: 0 18px; }
.invoice-nav strong { font-size: 22px; }
.invoice-nav button { border: 0; background: transparent; color: #555; font-size: 28px; line-height: 1; }
.invoice-tabs { display: flex; height: 48px; border-bottom: 1px solid #eee; }
.invoice-tabs button { position: relative; flex: 1; border: 0; color: #777; background: #fff; font-size: 16px; }
.invoice-tabs button.active { color: #1677ff; font-weight: 600; }
.invoice-tabs button.active::after { position: absolute; right: 28%; bottom: 0; left: 28%; height: 2px; content: ""; background: #1677ff; }
main { padding: 12px; }
article { position: relative; margin-bottom: 12px; padding: 16px; background: #fff; border-radius: 10px; }
article div { display: flex; justify-content: space-between; }
article span { padding: 3px 8px; border-radius: 10px; font-size: 12px; }
.success { color: #159b55; background: #eaf8f0; }
.failed { color: #e34d4d; background: #fff0f0; }
.pending { color: #d98a15; background: #fff6e7; }
h3 { margin: 12px 0; }
p { margin: 7px 0; color: #888; font-size: 12px; }
article b { position: absolute; right: 16px; bottom: 16px; color: #f25b3d; font-size: 18px; }
.load-more { width: 100%; height: 42px; border: 0; border-radius: 21px; color: #fff; background: #3978f6; }
.empty { padding: 60px 0; text-align: center; color: #999; }
</style>
